<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// console.log("document.cookie",document.cookie)
export default {
  name: "app",
  watch: {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* min-height: 100vh; */
  overflow: hidden;
  font-family: PingFangSC-Semibold, PingFang SC;
}

body {
  /* min-width: 1200px; */
}

.detel_color {
  border: none !important;
  background-color: red !important;
}

.home {
  min-width: 1200px;
}

/* 给左边的导航栏的空白减少一点 */
.el-menu-item-group__title {
  padding: 0 !important;
}

/* 用于广告配置页的图片上传按钮边框样式 */
.el-upload {
  border: 1px dashed #eee !important;
}

/* 导航 */
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: rgb(0, 83, 173) !important;
}

.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  color: rgb(0, 83, 173) !important;
}

/* 走马灯-轮播图 */
.el-carousel__button {
  background-color: #d4e6ff !important;
}
.el-carousel__indicator.is-active button {
  /* opacity: 1; */
  background-color: #0050a7 !important;
}
.el-carousel__indicator:hover button {
  /* opacity: .72; */
  background-color: #0050a7 !important;
}
.el-carousel__indicator:hover button {
}

/* 分页 */
.el-dialog,
.el-pager li {
  background-color: transparent !important;
}
.el-pagination .btn-next,
.el-pagination .btn-prev {
  background-color: transparent !important;
}
.el-carousel__mask {
  background-color: transparent !important;
}
</style>
